import { render, staticRenderFns } from "./PickupPointDetailModal.vue?vue&type=template&id=0ae94c73&scoped=true&"
import script from "./PickupPointDetailModal.vue?vue&type=script&lang=js&"
export * from "./PickupPointDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointDetailModal.vue?vue&type=style&index=0&id=0ae94c73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae94c73",
  null
  
)

export default component.exports